import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_BANK_INTERFACE_MONITORING_COL_DEF, transferRowData } from "presentation/constant/BankInterfaceMonitoring/BankInterfaceMonitoringColumnDefinition";
import { useBankInterfaceMonitoringMaintenanceVM } from "presentation/hook/BankInterfaceMonitoring/useBankInterfaceMonitoringMaintenanceVM";
import { useBankInterfaceMonitoringMaintenanceTracked } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";


const BankInterfaceMonitoringTablePanel: React.FC = () => {
    const [bankInterfaceMonitoringState] = useBankInterfaceMonitoringMaintenanceTracked();
    const bankInterfaceMonitoringVM = useBankInterfaceMonitoringMaintenanceVM();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    let gridRef: any = useRef(null);
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(bankInterfaceMonitoringState.isSearchLoading || (
            !bankInterfaceMonitoringState.isSearchLoading &&
            bankInterfaceMonitoringState.bankInterfaceMonitoringEtys &&
            bankInterfaceMonitoringState.bankInterfaceMonitoringEtys.length) ? false : true);
    }, [bankInterfaceMonitoringState.isSearchLoading, bankInterfaceMonitoringState.bankInterfaceMonitoringEtys]);

    useEffect(() => {
        if (!onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();
    }, [onTableSelectionClicked])

    useEffect(() => {

        if (!bankInterfaceMonitoringState.selectedBankInterfaceMonitoringRows ||
            bankInterfaceMonitoringState.selectedBankInterfaceMonitoringRows.length <= 0) {
            if (!onTableSelectionClicked) {

                gridRef.current?.gridRef.current.api?.deselectAll();
            }
        }
    })

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        if (selectedRows && selectedRows.length > 0) {
            bankInterfaceMonitoringVM.onSelectedInterfaceMonitorings(selectedRows);
        }
    }, [bankInterfaceMonitoringVM])

    const memoInterfaceMonitoringTable = useMemo(() => {
        return (
            <NbisTable
                id='interface-monitoring-table'
                //headerLabel={BankInterfaceMonitoringMaintenanceConstant.TITLE}
                isNewColumnSetting={true}
                columns={INITIAL_BANK_INTERFACE_MONITORING_COL_DEF?.slice()}
                data={transferRowData(bankInterfaceMonitoringState.bankInterfaceMonitoringEtys ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"single"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [bankInterfaceMonitoringState.bankInterfaceMonitoringEtys, handleSelectionChange, showOverlay])

    return <><TableWrapper>{memoInterfaceMonitoringTable}</TableWrapper></>;
}

export default memo(BankInterfaceMonitoringTablePanel);
